module.exports = __webpack_public_path__ + "static/media/header-small.b1ea736e.png";